/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_LifetimeInputs */

const en_landing_pricing_lifetime = /** @type {(inputs: Landing_Pricing_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifetime`)
};

const zh_landing_pricing_lifetime = /** @type {(inputs: Landing_Pricing_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`买断`)
};

/**
* | output |
* | --- |
* | "Lifetime" |
*
* @param {Landing_Pricing_LifetimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_lifetime = /** @type {((inputs?: Landing_Pricing_LifetimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_LifetimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_lifetime(inputs)
	return zh_landing_pricing_lifetime(inputs)
});
export { landing_pricing_lifetime as "landing.pricing.lifetime" }